import React, { useEffect, useRef, useState, useContext } from "react";
import { Link, useNavigate } from "react-router-dom";

import { Badge, Form } from "react-bootstrap";
import AutoNumeric from "autonumeric";

import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { useOnboarding } from "../../../context/AdminSellerRegistrationOB";
import JWTContext from "../../../context/JWTContext";
import { SubmitHandler, useForm, Controller } from "react-hook-form";
import Swal from "sweetalert2";
import { useUploadSingleFile } from "../../../hooks/useUploadFile";
import { uploadSingleFile } from "../../../services/uploadService";

import PhoneInput from "react-phone-number-input";
import "react-phone-number-input/style.css";

import {
  GoogleMap,
  Marker,
  LoadScript,
  Autocomplete,
} from "@react-google-maps/api";

import MultiSelectWithReFetcher from "../../global/MultiSelectWithReFetcher";
import useProductCategory from "../../../hooks/useProductCategory";

const schema = yup
  .object({
    productCategoryIdList: yup.string().required(),
    productDescription: yup.string().required(),
    numberProduct: yup.number().required(),
    minPriceRange: yup.number().required(),
    maxPriceRange: yup.number().required(),
    // agreement:yup.boolean().oneOf([true], "You must agree")
  })
  .required();

const SellerShopInformationPersonal = () => {
  const navigate = useNavigate();

  const containerStyle = {
    width: "100%",
    height: "400px",
  };

  const [mapCenter, setMapCenter] = useState({
    lat: -6.9175,
    lng: 107.6191,
  });

  const { saveStep, data } = useOnboarding();
  const { register: registerAccount } = useContext(JWTContext);

  const [uploading, setUploading] = useState(false);
  const [attachments, setAttachments] = useState(""); // URLs only
  const [SellerIDattachment, setSellerIDattachment] = useState(""); // URLs only
  const [catalogue, setcatalogue] = useState([]); // URLs only
  const fileInputRef = useRef(null);
  const fileInputRefSellerID = useRef(null);
  const cataloguefileInputRef = useRef(null);
  const [position, setPosition] = useState(null);
  const autocompleteRef = useRef(null);

  const {
    fetchProductCategory,
    data: productCategory,
    dataOptions: productCategoryOptions,
    status: productCategoryStatus,
    error: productCategoryError,
  } = useProductCategory();

  const AutoNumericInput = ({ value, onChange, error }) => {
    const inputRef = useRef(null);
    const anRef = useRef(null);

    useEffect(() => {
      if (inputRef.current && !anRef.current) {
        anRef.current = new AutoNumeric(inputRef.current, value || 0, {
          digitGroupSeparator: ",",
          decimalCharacter: ".",
          decimalPlaces: 0,
          currencySymbol: "$ ",
          currencySymbolPlacement: "p",
          unformatOnSubmit: true,
        });
      }

      return () => {
        if (anRef.current) {
          anRef.current.remove();
          anRef.current = null;
        }
      };
    }, []);

    // 🔁 Restore value when navigating back
    useEffect(() => {
      if (anRef.current && value !== undefined && value !== null) {
        anRef.current.set(value);
      }
    }, [value]);

    return (
      <input
        ref={inputRef}
        className={`form-control ${error ? "is-invalid" : ""}`}
        onBlur={() => {
          const raw = anRef.current?.getNumber();
          onChange(raw); // store RAW number in RHF
        }}
      />
    );
  };

  console.log("productCategory", productCategory);

  const {
    control,
    register,
    handleSubmit,
    reset,
    watch,
    setValue,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(schema),
    defaultValues: {
      productCategoryIdList: data.productCategoryIdList ?? "",
      productDescription: data.productDescription ?? "",
      numberProduct: data.numberProduct ?? 0,
      minPriceRange: data.minPriceRange ?? 0,
      maxPriceRange: data.maxPriceRange ?? 0,
      // businessRegistrationNumber: data.citizenID ?? "",
      // businessCertificate: data.citizenID ?? "",
      // sellerId: data.citizenID ?? "",
      // catalogue: data.citizenID ?? "",
      // name: data.citizenID ?? "",
      // email: data.citizenID ?? "",
      // description: data.citizenID ?? "",
      // link: data.citizenID ?? "",
      // address: data.citizenID ?? "",
      // businessLatLong: data.citizenID ?? "",
      // shippingAddress: data.citizenID ?? "",
      // shippingLatLong: data.citizenID ?? "",
      // shippingHandler: data.citizenID ?? "",
      // logo: data.citizenID ?? "",
      // phone: data.phone ?? "",
      // suburb: data.suburb ?? "",
      // postcode: data.postcode ?? "",
      // state: data.state ?? "",
      // timeZoneInfoId: data.timeZoneInfoId ?? "",
      // banner: data.banner ?? "",
      // topBanner: data.topBanner ?? "",
      // contentBanner: data.contentBanner ?? "",
      // currency: data.currency ?? "",
      // bankAccountName: data.bankAccountName ?? "",
      // bankAccountNumber: data.bankAccountNumber ?? "",
      // productCategoryIdList: data.productCategoryIdList ?? "",
      // productDescription: data.productDescription ?? "",
      // numberProduct: data.numberProduct ?? "",
      // minPriceRange: data.minPriceRange ?? "",
      // maxPriceRange: data.maxPriceRange ?? "",
      // addressName: data.addressName ?? "",
      // packageId: data.packageId ?? "",
      // bankTransferId: data.bankTransferId ?? "",

      // agreement: data.agreement ?? false,
      // phone: data.phone ?? "",
      // phoneCC: data.phoneCC ?? "+62"
    },
  });

  const selectedCategory = watch("productCategoryIdList");

  const onSubmit = (data) => {
    // if (data.agreement) {

    saveStep({
      productCategoryIdList: data.productCategoryIdList ?? "",
      productDescription: data.productDescription,
      numberProduct: data.numberProduct,
      minPriceRange: parseInt(data.minPriceRange),
      maxPriceRange: parseInt(data.maxPriceRange),
    });
    navigate("/admin/seller-subscription-payment-company");

    // } else {
    //     Swal.fire({
    //         title: "Error",
    //         text: "Please accept the terms and conditions.",
    //         icon: "error"
    //     });
    // }
  };

  const readUserData = () => {
    if (localStorage.getItem("user") == null) {
      navigate("/login");
    }
  };

  useEffect(() => {
    readUserData();
    fetchProductCategory();
    console.log(attachments);
  }, []);

  console.log("selectedCategory", selectedCategory);

  return (
    <div className="shop-information text_quicksand">
      <div className="container">
        <form onSubmit={handleSubmit(onSubmit)}>
          <div className="text-18 fw-bold text-black mb-30">
            <span>Products Information</span>
          </div>

          <div className="form-group mb-40">
            <label className="form-label fw-bold mb-10">
              Type Of Products <span className="text-danger">*</span>
            </label>
            <MultiSelectWithReFetcher
              // isTouched={Boolean(touched.productCategoryList)}
              // isError={Boolean(errors.productCategoryList)}
              // isLoading={getCategoryStatus === ApiStatusEnum.loading}
              name={"productCategoryIdList"}
              label={""}
              options={productCategoryOptions}
              selectedValues={
                selectedCategory
                  ? productCategoryOptions.filter((option) =>
                      selectedCategory.split(",").includes(option.value),
                    )
                  : []
              }
              onChange={(name, values) => {
                console.log("selected categories", values);
                setValue(name, values.map((item) => item.value).toString()); // values is an array of selected options
              }}
              // reFetch={() => fetchCategories('' as string)}
              errorMessage={""}
            />
            {/*<select className="form-control form-select" {...register("productCategoryIdList")}>*/}
            {/*    <option>-select Category-</option>*/}
            {/*</select>*/}
          </div>

          <div className="form-group mb-40">
            <label className="form-label fw-bold mb-10">
              Product Description Brief{" "}
            </label>
            <textarea
              className="form-control form-textarea h-auto"
              rows={"6"}
              {...register("productDescription")}
            />
          </div>

          <div className="form-group mb-40">
            <label className="form-label fw-bold mb-10">
              Number of product listed{" "}
            </label>
            <input
              type="number"
              className="form-control"
              min={0}
              {...register("numberProduct")}
            />
          </div>

          <div className="text-18 fw-bold text-black mb-30">
            <span>Pricing & Delivery</span>
          </div>

          <div className="form-group mb-40">
            <label className="form-label fw-bold mb-10">
              Average Price Range<span className="text-danger">*</span>{" "}
            </label>
            {/* <input type="text" className="form-control autonumeric" {...register("minPriceRange")} /> */}
            <div className="row">
              <div className="col-12 col-md-6">
                <label className="form-label mb-10">
                  Min Price<span className="text-danger">*</span>
                </label>
                <Controller
                  name="minPriceRange"
                  control={control}
                  render={({ field, fieldState }) => (
                    <AutoNumericInput
                      value={field.value}
                      onChange={field.onChange}
                      error={fieldState.error}
                    />
                  )}
                />
              </div>
              <div className="col-12 col-md-6">
                <label className="form-label mb-10">
                  Max Price<span className="text-danger">*</span>
                </label>
                <Controller
                  name="maxPriceRange"
                  control={control}
                  render={({ field, fieldState }) => (
                    <AutoNumericInput
                      value={field.value}
                      onChange={field.onChange}
                      error={fieldState.error}
                    />
                  )}
                />
              </div>
            </div>
          </div>

          <div className="d-flex justify-content-end">
            {/* <button className="btn btn_mart_primary" onClick={() => navigate("/registration-shop-information")} >Next</button> */}
            <button className="btn btn_mart_primary" type="submit">
              Next
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default SellerShopInformationPersonal;
